













import Vue from 'vue'
import { AdoptibleOffer } from './TakeOverAppointment.graphql'

export default Vue.extend({
  apollo: {
    offers: {
      query: AdoptibleOffer,
      variables() {
        return {
          id: this.offerId,
        }
      },
    },
  },
  data() {
    return {
      offers: { nodes: [] },
    }
  },
  props: {
    offerId: {
      type: String,
      required: true,
    },
    value: {
      required: true,
      type: Object,
    },
  },
})
